import { TNavigation } from 'src/components/navigation/Navigation';
import { BulbIcon, ComingSoonIcon, HomeIcon, NoteIcon } from 'src/components/common/common.icons';
import ChatIcon from 'src/components/common/common.icons/ChatIcon';
import { useAppSelector } from 'src/store/hooks';
import { useMemo } from 'react';
import MarketplaceIcon from 'src/components/common/common.icons/MarketplaceIcon';
import CohortIcon from 'src/components/common/common.icons/CohortIcon';
import BlogIcon from 'src/components/common/common.icons/BlogIcon';
import DiscoverIcon from 'src/components/common/common.icons/DiscoverIcon';
import VentureIcon from 'src/components/common/common.icons/VentureIcon';
import VentureNewIcon from 'src/components/common/common.icons/VentureNewIcon';

const useSideNavItems = () => {
  // Hooks
  const { notificationCount, chatCount } = useAppSelector(
    (store) => store.chat
  );

  const SIDE_NAV_ITEMS: TNavigation[] = useMemo(() => {
    return [
      {
        url: '/dashboard',
        key: 'dashboard',
        startIcon: <HomeIcon />,
        title: 'Home',
        state: 'default',
        notificationCount: 0,
        availableToUserType: 'All'
      },
      {
        availableToUserType: 'All',
        key: 'score',
        notificationCount: 0,
        startIcon: <VentureIcon />,
        endIcon: <VentureNewIcon className="no-hover-state"/>,
        state: 'default',
        title: 'Funding Access',
        url: `/score`
      },
       {
        url: '/chat',
        key: 'chat',
        startIcon: <ChatIcon />,
        title: 'Chat',
        state: 'default',
        notificationCount: chatCount,
        availableToUserType: 'All'
      },
      {
        url: '/idea-hub',
        key: 'idea-hub',
        startIcon: <BulbIcon />,
        title: 'Idea hub',
        state: 'default',
        // notificationCount: ideaHubNotificationCount,
        notificationCount: 0,
        availableToUserType: 'User'
      },
      // {
      //   url: '/resources',
      //   key: 'resources',
      //   startIcon: <NoteIcon />,
      //   endIcon: <ComingSoonIcon className="no-hover-state" />,
      //   title: 'Resources',
      //   state: 'default',
      //   notificationCount: 0,
      //   availableToUserType: 'User'
      // },
      {
        availableToUserType: 'All',
        key: 'discover',
        notificationCount: 0,
        startIcon: <DiscoverIcon />,
        state: 'default',
        title: 'Discover',
        url: `/discover`
      },
      {
        availableToUserType: 'All',
        key: 'venture',
        notificationCount: 0,
        startIcon: <VentureIcon />,
        state: 'default',
        title: 'Venture Verse',
        url: `/venture`
      },
      {
        availableToUserType: 'All',
        key: 'blogs',
        notificationCount: 0,
        startIcon: <BlogIcon />,
        state: 'default',
        title: 'Insights',
        url: `/blogs`
      },
      {
        availableToUserType: 'User',
        key: 'cohort',
        notificationCount: 0,
        startIcon: <CohortIcon />,
        state: 'default',
        title: 'Cohort',
        url: `/cohort`
      },
      {
        availableToUserType: 'All',
        key: 'marketplace',
        notificationCount: 0,
        startIcon: <MarketplaceIcon />,
        state: 'default',
        title: 'MarketPlace',
        url: `/marketplace`
      }
    ];
  }, [chatCount, notificationCount]);

  return SIDE_NAV_ITEMS;
};

export default useSideNavItems;
